import Resource from '../svgs/outrunService/resource.svg'
import AutoDeployment from '../svgs/outrunService/autoDeployment.svg'
import Integrat from '../svgs/outrunService/integrat.svg'
import Deployment from '../svgs/outrunService/deployment.svg'
import Management from '../svgs/outrunService/management.svg'
import Star from '../svgs/outrunService/star.svg'
import Modernization from '../svgs/outrunService/modernization.svg'
import OutrunCloud from '../public/outrun.svg';

export const functionOutrunServiceList = [
  {
    subtitle: 'features.resource.title',
    subdescription: 'features.resource.description',
    img: Resource,
  },
  {
    subtitle: 'features.deployment.title',
    subdescription: 'features.deployment.description',
    img: AutoDeployment,
  },

  {
    subtitle: 'features.integrat.title',
    subdescription: 'features.integrat.description',
    img: Integrat,
  },
  {
    subtitle: 'features.autoDeployment.title',
    subdescription: 'features.autoDeployment.description',
    img: Deployment,
  },
  {
    subtitle: 'features.management.title',
    subdescription: 'features.management.description',
    img: Management,
  }
];

export const caseList = [
  {
    subtitle: 'cases.development.title',
    subdescription: 'cases.development.description',
  },
  {
    subtitle: 'cases.security.title',
    subdescription: 'cases.security.description',
  },
]

export const benefitList = [
  {
    subtitle: 'benefits.environment.title',
    subdescription: 'benefits.environment.description',
    img: Star,
  },
  {
    subtitle: 'benefits.release.title',
    subdescription: 'benefits.release.description',
    img: Resource,
  },
  {
    subtitle: 'benefits.modernization.title',
    subdescription: 'benefits.modernization.description',
    img: Modernization
  },
]

export const benefitClientList = [
  {
    subtitle: 'benefitsCloud.costs.title',
    subdescription: 'benefitsCloud.costs.description',
  },
  {
    subtitle: 'benefitsCloud.scalability.title',
    subdescription: 'benefitsCloud.scalability.description',
  },
  {
    subtitle: 'benefitsCloud.security.title',
    subdescription: 'benefitsCloud.security.description',
  },
]

export const relatedServices = [
  {
    title: 'Outrun Cloud',
    img: OutrunCloud,
    link: '/outrun-cloud'
  },
];
